import { Media } from "components/gallery/gallerySlice";

export const getFileUrl = (media: Media, thumbnail = false) => {
  if (!media) return undefined;

  let url = undefined;

  if (media.type === "video") {
    url = media.proxy_large || media.proxy_medium || media.proxy_small;
  }

  if (thumbnail)
    url = media?.files?.find((f) => f.details === "thumbnail_quality")?.url;
  if (!url)
    url = media?.files?.find((f) => f.details === "compressed_quality")?.url;
  if (!url)
    url = media?.files?.find((f) => f.details === "photographer_quality")?.url;

  if (!url) return undefined;

  return url;
};

export const getVideoSpriteUrl = (media: Media, count = 20): string | null => {
  if (!media) return null;
  const counts = [20, 30, 60];

  if (!counts.includes(count)) {
    console.warn(
      `Param '${count}' passed to getVideoSprite() is not valid. Must be one of ${counts.toString()}`
    );
    count = 20;
  }

  const url = media?.files?.find(
    (f) =>
      f.details === "video_sprite" &&
      f.url.toString().includes(`sprite_${count}`)
  )?.url;

  if (!url) return null;

  return url;
};
